// extracted by mini-css-extract-plugin
export var chip = "_43-0";
export var filterDropdown = "_43-5";
export var filterItem = "_43-6";
export var icon = "_43-1";
export var removeButton = "_43-3";
export var removeIcon = "_43-4";
export var separator = "_43-2";